import React, { createContext, useContext, useState, useCallback } from 'react';

/**
 * Prescription upload flow – holds uploaded files and date across navigation
 * (e.g. from Lab Tests modal to prescription-details screen).
 */
const PrescriptionUploadContext = createContext(null);

export function PrescriptionUploadProvider({ children }) {
  const [uploadedFiles, setUploadedFiles] = useState([]); // [{ file: File, type: 'image'|'pdf' }]
  const [prescriptionDate, setPrescriptionDateState] = useState(''); // YYYY-MM-DD for input type="date"

  const addFile = useCallback((file, type) => {
    if (!file || !type) return;
    setUploadedFiles((prev) => [...prev, { file, type: type === 'pdf' ? 'pdf' : 'image' }]);
  }, []);

  const removeFile = useCallback((index) => {
    setUploadedFiles((prev) => prev.filter((_, i) => i !== index));
  }, []);

  const clearPrescription = useCallback(() => {
    setUploadedFiles([]);
    setPrescriptionDateState('');
  }, []);

  const setPrescriptionDate = useCallback((value) => {
    setPrescriptionDateState(typeof value === 'string' ? value : '');
  }, []);

  const value = {
    uploadedFiles,
    addFile,
    removeFile,
    clearPrescription,
    prescriptionDate,
    setPrescriptionDate,
  };

  return (
    <PrescriptionUploadContext.Provider value={value}>
      {children}
    </PrescriptionUploadContext.Provider>
  );
}

export function usePrescriptionUpload() {
  const ctx = useContext(PrescriptionUploadContext);
  if (!ctx) throw new Error('usePrescriptionUpload must be used within PrescriptionUploadProvider');
  return ctx;
}
